var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIsolation3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.265 113.555C213.145 131.705 213.12 112.37 213 130.5L125.655 173.625V153.005C154.855 139.855 184.065 126.705 213.265 113.555Z",
    fill: "#72D09A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.335 100.645V172.655L125.695 173.625L125.865 153.005L82.6049 77.0054L39.3449 100.635L39.335 100.645Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.195 92.9854C28.525 95.5354 33.855 98.0754 39.165 100.645L82.425 77.0154C101.795 105.015 121.165 133.015 140.535 161.015C169.605 145.235 198.685 129.475 227.755 113.705C208.465 82.8454 189.175 52.0054 169.875 21.1354C140.725 34.0254 111.585 46.9454 82.445 59.8354C62.675 70.8754 42.9351 81.9354 23.1851 92.9854H23.195Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.195 92.9855L39.165 100.645L82.425 77.0154L125.685 153.015L140.515 161.015L82.425 59.8354L23.1851 92.9855H23.195Z",
    fill: "#72D09A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.165 129.185V177.845L66.485 193.166L118.225 224.975L125.375 229.245L125.655 173.585",
    fill: "#FECECA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M212.911 173.972C212.831 162.622 213.103 126.217 213.103 126.217L125.655 173.584C125.555 185.694 125.455 217.115 125.375 229.225L212.911 173.972Z",
    fill: "#FEE4E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.165 177.845L77.485 148.666L39.165 129.185V177.845Z",
    fill: "#FEE4E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsolation3);
export default __webpack_public_path__ + "static/media/isolation3.7ecdb3d957b35ab78bdf11b5d21b32b3.svg";
export { ForwardRef as ReactComponent };